<template lang="pug">
  CommonSection(title="Описание" v-if="company" :back="{ title: company.name, name: 'company-list', params: { companyId: $route.params.companyId } }")
    .b-company-settings-page
      FormBlock._main
        h2._title Контактные данные
        BaseTextarea(v-model="contacts" type="textarea")
        Btn(@click="changeContacts")._btn Сохранить
      FormBlock._aside
        h2._title Аватар
        AvatarEditable(:avatar="company.avatar" @change="changeAvatar" placeholder="no-avatar-project")

</template>

<script>
import api from '@/api/company';

import CommonSection from '@/components/CommonSection.vue';
import AvatarEditable from '@/components/AvatarEditable.vue';
import BaseInput from '@/components/BaseInput.vue';
import FormBlock from '@/components/FormBlock.vue';
import BaseTextarea from '@/components/BaseTextarea.vue';

export default {
  name: 'CompanySettingsPage',
  components: { BaseTextarea, FormBlock, BaseInput, AvatarEditable, CommonSection },
  data() {
    return {
      contacts: '',
    };
  },
  computed: {
    company() { return this.$store.getters['company/withMembers']; },
  },
  watch: {
    company: {
      immediate: true,
      handler(val) {
        this.contacts = val.contacts;
      }
    },
  },
  methods: {
    async changeAvatar(avatar) {
      await api.update(this.company.id, { avatar: avatar?.['@id'] ?? null }, true);
      await this.$store.dispatch('company/refetch');
    },
    async changeContacts() {
      const { contacts } = this;
      await api.update(this.company.id, { contacts }, true);
      await this.$store.dispatch('company/refetch');
    },
  },
};
</script>


<style lang="scss">
  .company-settings-page {
    display: grid;
    grid-template-columns: 1fr 300px;
    gap: 38px;
    align-items: start;

    &__title {
      font-size: 20px;
    }

    &__main {
      display: flex;
      flex-direction: column;
      gap: 30px;
    }

    &__btn {
      align-self: flex-end;
    }

    &__aside {
      display: flex;
      flex-direction: column;
      gap: 30px;
      align-items: center;
    }
  }
</style>
